module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "_1-CN ParaOverride-7",
    attrs: {
      "id": "_idParaDest-8"
    }
  }, [_c('span', {
    staticClass: "leading-139-5 CharOverride-12"
  }, [_vm._v("P")]), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("ART ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "PTS1_Part_subtitle_1_after_PT1"
  }, [_vm._v("A PERFECT TEAM")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25eaed9c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eBookVR02457.vue
// module id = 84
// module chunks = 0